export const idRivenditore = 'LI0002';

export const selectPeriod = 'select-period';
export const selectPeriodLotto = 'select-period-lotto';
export const selectType = 'select-type';
export const selectPlayState = 'select-play-state';
export const selectApplicationCode = 'select-application-code';
export const selectTransactionState = 'select-transaction-state';
export const selectState = 'select-bets-state';
export const selectBetsType = 'select-bets-type';
export const onlyCheckWinnings = 'only-check-winnings';
export const selectBetsTototipster = 'select-bets-tototipster';
export const hideNavigation = 'hide-navigation';

export const mapFormNameToCanonicalName = {
  [selectPeriod]: 'period',
  [selectPeriodLotto]: 'period-lotto',
  [selectType]: 'type',
  [selectPlayState]: 'play-state',
  [selectApplicationCode]: 'application-code',
  [selectTransactionState]: 'transaction-state',
  [selectState]: 'bets-state',
  [selectBetsType]: 'bets-type',
  [onlyCheckWinnings]: 'only-check-winnings',
  [selectBetsTototipster]: 'select-bets-tototipster',
  [hideNavigation]: 'hide-navigation',
};
